import { getAddressFieldConditionalComponents } from '../../../document/components/AddressField.tsx';
import { ArticleNumberFieldConditionalComponents } from '../../../document/components/ArticleNumberField.tsx';
import {
    getCustomerFieldConditionalComponents,
    getCustomerFieldGroupConditionalComponents,
} from '../../../document/components/CustomerField.tsx';
import { OrderNumberFieldConditionalComponents } from '../../../document/components/OrderNumberField.tsx';
import { DocumentType } from '../../../document/constants.ts';
import DocumentAssistance from '../../../document/pages/Assistance';
import {
    ASSISTANCE_PATH,
    ASSISTANCE_TAB_PATH,
    CHANNEL_FINISHED_PATH,
    CHANNEL_PATH,
    CHANNEL_TESTING_PATH,
    OVERVIEW_FINISHED_PATH,
    OVERVIEW_PATH,
    OVERVIEW_TESTING_PATH,
} from '../constants.ts';
import {
    GET_CHANNELS_OVERVIEW_DATA,
    GET_ASSISTANCE_OVERVIEW_DATA,
    GET_NEXT_ASSISTANCE_RECORD,
    GET_RELATED_DOCUMENT,
    ORDER_CONFIRMATION_EXTRACT_TEXT,
    RE_UPLOAD_FILE,
    REOPEN_FOR_ASSISTANCE,
    RETRY_STEP,
    SEND_TO_LABELING,
} from '../queries.ts';

export const documentTypeName = 'orderConfirmation';

const OrderConfirmationAssistance = (props) => {
    const documentConfiguration = {
        documentType: DocumentType.OrderConfirmation,
        documentTypeName: 'orderConfirmation',
        supportsAgenticExtraction: true,
        GET_ASSISTANCE_OVERVIEW_DATA: GET_ASSISTANCE_OVERVIEW_DATA,
        GET_CHANNELS_OVERVIEW_DATA: GET_CHANNELS_OVERVIEW_DATA,
        GET_NEXT_ASSISTANCE_RECORD: GET_NEXT_ASSISTANCE_RECORD,
        GET_RELATED_DOCUMENT: GET_RELATED_DOCUMENT,
        RETRY_STEP: RETRY_STEP,
        REOPEN_FOR_ASSISTANCE: REOPEN_FOR_ASSISTANCE,
        ASSISTANCE_PATH: ASSISTANCE_PATH,
        ASSISTANCE_TAB_PATH: ASSISTANCE_TAB_PATH,
        OVERVIEW_PATH: OVERVIEW_PATH,
        OVERVIEW_FINISHED_PATH: OVERVIEW_FINISHED_PATH,
        OVERVIEW_TESTING_PATH: OVERVIEW_TESTING_PATH,
        CHANNEL_PATH: CHANNEL_PATH,
        CHANNEL_FINISHED_PATH: CHANNEL_FINISHED_PATH,
        CHANNEL_TESTING_PATH: CHANNEL_TESTING_PATH,
        RE_UPLOAD_FILE: RE_UPLOAD_FILE,
        EXTRACT_TEXT: ORDER_CONFIRMATION_EXTRACT_TEXT,
        SEND_TO_LABELING: SEND_TO_LABELING,
        components: {
            Field: [
                ...getCustomerFieldConditionalComponents('supplier'),
                ...getCustomerFieldConditionalComponents('buyer'),
                ...getAddressFieldConditionalComponents('delivery_address'),
                ...ArticleNumberFieldConditionalComponents,
                ...OrderNumberFieldConditionalComponents,
            ],
            HeaderDataFieldGroup: [
                ...getCustomerFieldGroupConditionalComponents('supplier'),
                ...getCustomerFieldGroupConditionalComponents('buyer'),
            ],
        },
    };

    return <DocumentAssistance documentConfiguration={documentConfiguration} {...props} />;
};

export default OrderConfirmationAssistance;
